import { getInputControlState } from 'ui/forms/input-control/input-control.helpers';
import {
  InputControlAsterisk,
  InputControlLabel,
  InputControlMessage,
  InputControlRoot,
  InputControlSupportiveText,
} from 'ui/forms/input-control/input-control.styles';
import type { InputControlProps } from 'ui/forms/input-control/input-control.types';

const InputControl = ({
  id,
  size,
  children,
  label,
  required,
  disabled,
  error,
  errorMessage,
  supportiveText,
  helperText,
  counterText,
  sx,
}: InputControlProps) => {
  const { isError, supportiveTextId, errorMessageId, helperTextId } =
    getInputControlState({
      id,
      disabled,
      error,
      errorMessage,
      supportiveText,
      helperText,
    });

  return (
    <InputControlRoot fullWidth disabled={disabled} error={isError} sx={sx}>
      {!!label && (
        <InputControlLabel htmlFor={id} fieldSize={size}>
          {label}
          {required && (
            <InputControlAsterisk aria-hidden="true" fieldSize={size}>
              *
            </InputControlAsterisk>
          )}
        </InputControlLabel>
      )}
      {supportiveTextId && (
        <InputControlSupportiveText id={supportiveTextId} fieldSize={size}>
          {supportiveText}
        </InputControlSupportiveText>
      )}
      {children}
      {errorMessageId && (
        <InputControlMessage id={errorMessageId} role="alert">
          {errorMessage}
        </InputControlMessage>
      )}
      {helperTextId && (
        <InputControlMessage id={helperTextId} error={false}>
          {helperText}
        </InputControlMessage>
      )}
      {!!counterText && (
        <InputControlMessage error={false}>{counterText}</InputControlMessage>
      )}
    </InputControlRoot>
  );
};

export default InputControl;
